import { Box, Typography } from "@material-ui/core";

const FalconAITemplates = () => {
  return (
    <Box>
      <Typography variant="h4">Falcon AI Templates</Typography>
    </Box>
  );
};

export default FalconAITemplates;
